import { COLUMN_WIDTHS_STATE_FIELD } from '../components/Table/constants';

export const getTableSavedState = (tableName) => {
  let currentSavedState = [];

  if (!tableName) {
    return {};
  }
  const saved = localStorage.getItem(tableName) || '';

  try {
    currentSavedState = JSON.parse(saved);
  } catch (error) {
    currentSavedState = {};
  }

  return currentSavedState;
};

export const getColumnWidthsInitialState = (defaultColumns, tableName) => {
  if (!defaultColumns) {
    return [];
  }

  if (tableName) {
    const savedTableState = getTableSavedState(tableName);
    const savedColumns = savedTableState[COLUMN_WIDTHS_STATE_FIELD] || [];
    return defaultColumns.map((col) => {
      const defaultColumn = { ...col };
      const savedCol = savedColumns.find(
        (savedColumn) => savedColumn.id === col.accessor,
      );

      if (savedCol) {
        defaultColumn.width = savedCol.width;
      }
      return defaultColumn;
    });
  }

  return defaultColumns;
};

export const updateTableSavedTableState = (
  tableName,
  fieldToUpdate,
  updatedValue,
) => {
  const currentSavedTableState = getTableSavedState(tableName);
  localStorage.setItem(
    tableName,
    JSON.stringify({
      ...currentSavedTableState,
      [fieldToUpdate]: updatedValue,
    }),
  );
};
